import axios from '@/plugins/axios'
import Errors from '@/utils/Errors'
import { snakeCase } from '@/utils/Helper'
import _ from 'lodash'

class Form {
  constructor(params = {}) {
    this._params = _.clone(params)
    this.params = _.clone(params)
    this.sending = false
    this.errors = new Errors()
    this.http = axios
  }

  clear() {
    this.params = _.clone(this._params)
    this.errors.clear()
  }

  reset() {
    this.clear()
  }

  formData(data) {
    const form = new FormData()

    _.each(data, (value, key) => {
      form.append(key, value)
    })

    return form
  }

  async delete({ url }) {
    return await this.request(this.http.delete(url))
  }

  async post({ url, data = this.params, options = {} }) {
    return await this.request(this.http.post(url, snakeCase(data), options))
  }

  async postFormData({ url, data = this.params, options = {} }) {
    return await this.request(
      this.http.post(
        url,
        this.formData(snakeCase(data)),
        Object.assign({}, options, {
          headers: {
            'content-type': 'multipart/form-data',
          },
        })
      )
    )
  }

  async put({ url, data = this.params, options = {} }) {
    return await this.request(this.http.put(url, snakeCase(data), options))
  }

  async putFormData({ url, data = this.params, options = {} }) {
    return await this.request(
      this.http.put(
        url,
        this.formData(snakeCase(data)),
        Object.assign({}, options, {
          headers: {
            'content-type': 'multipart/form-data',
          },
        })
      )
    )
  }

  async get({ url, data = this.params }) {
    return await this.request(
      this.http.get(url, {
        params: snakeCase(data),
      })
    )
  }

  async paginate({ url, data = this.params }) {
    return await this.request(
      this.http.get(url, {
        params: snakeCase(data),
      })
    )
  }

  async request(request) {
    this.sending = true
    this.errors.clear()

    return await request
      .then(response => {
        this.sending = false

        return Promise.resolve(response)
      })
      .catch(error => {
        this.sending = false

        if (error.response && error.response.status === 422) {
          this.errors.record(error.response.data.errors)
        }

        return Promise.reject(error.response)
      })
  }
}

export default Form
